import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyC-Om_omg8ebi2C9qcrGJyNerx3mm7YSL4",
  authDomain: "mygamehub-7110d.firebaseapp.com",
  projectId: "mygamehub-7110d",
  storageBucket: "mygamehub-7110d.firebasestorage.app",
  messagingSenderId: "748519329846",
  appId: "1:748519329846:web:80daa0c604c827714bc897",
  databaseURL: "https://mygamehub-7110d-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app); 